<template>
  <div>
    <main-nav @availEvent='handleToggleAvail()' :user='User' :is-plugin-view='true' :recent-func='loadRecent' :high-func='loadHighReport'
      :bim-func='loadBIM' :lost-func='loadLost' :pc-func='loadRecent' :cust-search-func='custSearchFunc' :user-info-handlers='userInfoHandlers()'
      :toggleAvail='toggleAvail' :low-func='loadLowReport'></main-nav>
  </div>
</template>

<script>
  import MainNav from '@/components/Nav/MainNav'
  import {
    mapGetters
  } from 'vuex'
  import {
    UserAvailability
  } from '@/lib/utilities/enums'
  import {
    MessengerAPIClient
  } from '@/lib/data_access/messenger.js'
  export default {
    name: 'pluginNav',
    components: {
      MainNav
    },
    data() {
      return {
        toggleAvail: false
      }
    },
    computed: {
      ...mapGetters(['User'])
    },
    methods: {
      loadHighReport() {
        let vm = this;
        vm.$router.push({
          name: 'Plugin.CustomerList',
          query: Object.assign({}, vm.$route.query, {
            report: 'highIntensity'
          })
        })
      },
      loadLowReport() {
        let vm = this;
        vm.$router.push({
          name: 'Plugin.CustomerList',
          query: Object.assign({}, vm.$route.query, {
            report: 'losingIntensity'
          })
        })
      },
      loadLost() {
        let vm = this;
        vm.$router.push({
          name: 'Plugin.CustomerList',
          query: Object.assign({}, vm.$route.query, {
            report: 'lostLeads'
          })
        })
      },
      loadRecent() {
        let vm = this;
        vm.$router.push({
          name: 'Plugin.CustomerList',
          query: Object.assign({}, vm.$route.query, {
            report: 'recent'
          })
        })
      },
      loadBIM() {
        let vm = this;
        vm.$router.push({
          name: 'Plugin.CustomerList',
          query: Object.assign({}, vm.$route.query, {
            report: 'soldBim'
          })
        })
      },
      custSearchFunc() {
        let vm = this;
        vm.$router.push({
          name: 'Plugin.CustomerList',
          query: Object.assign({}, vm.$route.query, {
            report: 'search'
          })
        })

      },
      userInfoHandlers: function () {
        let vm = this;
        return {
          availabilityToggler: vm.availabilityToggler
        }
      },
      availabilityToggler: function () {
        let vm = this;
        if (vm.User.Availability == UserAvailability.NotAvailable) {
          MessengerAPIClient.clockIn().then(function () {})
        } else {
          vm.toggleAvail = true
        }
      },
      handleToggleAvail: function () {
        let vm = this;
        vm.toggleAvail = false
      },
      test: function () {}
    }
  }

</script>

<style>


</style>



// WEBPACK FOOTER //
// src/views/Plugin/PluginNav.vue